var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "py-4" }, [
    _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "pb-4" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("div", [
                  _c("h1", { staticClass: "h4 ls-tight" }, [
                    _vm._v(
                      "Factura electrónica - " +
                        _vm._s(_vm.data.type) +
                        _vm._s(_vm.data.id)
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              _c("div", { staticClass: "hstack gap-2 justify-content-end" }, [
                (!_vm.primary && !_vm.loading) || _vm.loading === "generate"
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-success btn-h px-3",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.GENERATE()
                          },
                        },
                      },
                      [
                        _vm.count == 1
                          ? _c(
                              "div",
                              {
                                staticClass: "spinner-border spinner-border-sm",
                                attrs: { role: "status" },
                              },
                              [
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("Loading..."),
                                ]),
                              ]
                            )
                          : _c("small", [
                              _c("i", {
                                staticClass: "fa-solid fa-rotate-right",
                              }),
                              _vm._v(" Generar FEL"),
                            ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
      _c("div", { staticClass: "container-fluid vstack gap-5" }, [
        _vm.loading == "table"
          ? _c("div", { staticClass: "w-100 pt-5" }, [_vm._m(0)])
          : _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body p-0" },
                    [
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.data.fels,
                          loading: _vm.loading == "table",
                          "item-class": _vm.ITEM_ROW_BACKGROUND,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item.created_at",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm._f("DATETIME")(item.created_at)
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.tipo_documento",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm._f("TIPODOCUMENTO")(
                                          item.tipo_documento
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.estado",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "v-tooltip",
                                    {
                                      staticClass: "mx-1",
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "div",
                                                  _vm._g(
                                                    _vm._b(
                                                      { staticClass: "nowrap" },
                                                      "div",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          _vm._f("ESTADO")(
                                                            item.estado
                                                          )
                                                        ) +
                                                        " ...\n                                            "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("small", [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(
                                              _vm._f("ESTADO")(item.estado)
                                            ) +
                                            "\n                                        "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.xml_error",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "v-tooltip",
                                    {
                                      staticClass: "mx-1",
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "div",
                                                  _vm._g(
                                                    _vm._b(
                                                      { staticClass: "nowrap" },
                                                      "div",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(item.xml_error) +
                                                        " ...\n                                            "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("small", [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(item.xml_error) +
                                            "\n                                        "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.pdf",
                              fn: function (ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  item.estado == 1
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "btn btn-danger btn-h",
                                          attrs: {
                                            href:
                                              _vm.COMPROBANTES_ELECTRONICOS_URL +
                                              "/action_xml.php?token=" +
                                              item.clave +
                                              "&op=pdf&ambiente=" +
                                              _vm.COMPROBANTES_ELECTRONICOS_AMBIENTE,
                                            download: "",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("small", [
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-file-pdf",
                                            }),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "item.xml",
                              fn: function (ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  item.estado == 1
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "btn btn-dark btn-h",
                                          attrs: {
                                            href:
                                              _vm.COMPROBANTES_ELECTRONICOS_URL +
                                              "/action_xml.php?token=" +
                                              item.clave +
                                              "&op=xml&ambiente=" +
                                              _vm.COMPROBANTES_ELECTRONICOS_AMBIENTE,
                                            download: "",
                                            target: "_blank",
                                            type: "button",
                                          },
                                        },
                                        [
                                          _c("small", [
                                            _c("i", {
                                              staticClass: "fa-solid fa-file",
                                            }),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "item.response",
                              fn: function (ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  item.estado == 1
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "btn btn-dark btn-h",
                                          attrs: {
                                            href:
                                              _vm.COMPROBANTES_ELECTRONICOS_URL +
                                              "/action_xml.php?token=" +
                                              item.clave +
                                              "&op=hacienda&ambiente=" +
                                              _vm.COMPROBANTES_ELECTRONICOS_AMBIENTE,
                                            download: "",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("small", [
                                            _c("i", {
                                              staticClass: "fa-solid fa-file",
                                            }),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "item.reenviar",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  item.estado == 1
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary btn-h",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.REENVIAR_FEL()
                                            },
                                          },
                                        },
                                        [
                                          _c("small", [
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-paper-plane",
                                            }),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border text-primary",
          attrs: { role: "status" },
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Listado")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }